export const SITE_CONFIG = {
  company: {
    name: '株式会社うるおいエレガンス',
    nameEn: 'Uruoi Elegance Inc.',
    description: '本来のあなたで、うるおう人生を',
    representative: '御子柴 詩織',
    businesses: [
      { name: '体質改善・美容・漢方講座の企画運営', description: '' },
      { name: '四柱推命・東洋思想による才能開花サポート', description: '' },
      { name: '女性向け起業・ブランディング・集客支援', description: '' },
      { name: 'オンライン講座・コミュニティ運営', description: '' },
      { name: '商品開発・監修・講演活動', description: '' },
    ],
    address: '東京都港区青山2丁目2-15 ウィン青山924',
    phone: '090-8036-3536',
    hours: '10:00〜17:00',
    established: '2023年2月6日',
  },
  contact: {
    email: 'info@uruoi-elegance.com',
  },
  social: {
    instagram: '',
    blog: '',
    mailMagazine: '',
  },
  meta: {
    title: 'うるおいエレガンス | 漢方×四柱推命',
    description: '体質と運命、両面からあなた本来の輝きを取り戻す。漢方×四柱推命で、本来のあなたで、うるおう人生を。',
    siteUrl: '',
  },
  copyright: {
    year: 2025,
    holder: 'うるおいエレガンス',
  },
};
